import { TeamNavigationFragment } from '@/components/Navigation/ContextNavigationFragments';
import { graphql } from '@/gql/graphql';

export const TeamDetailToolbarFragment = graphql(`
  fragment TeamDetailToolbar on team {
    id
    title
    avatar_id
    home_primary_color
    ...TeamNavigation
    ... on team @_optional {
      on_team
      root_event {
        id
        title
      }
      chats(limit: 1) {
        id
      }
    }
  }
`, [TeamNavigationFragment]);
